import React, { useState, useEffect, useRef }from 'react';
import { Row, Col, Container, Card } from 'reactstrap';
import BusinessGeneralTile from '../business-general-tile/BusinessGeneralTile';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";
import Pagination from '@material-ui/lab/Pagination';
import { makeStyles } from '@material-ui/core/styles';
import { LargeBusiness, moduleMargins, htmlWidget } from '../../Constants';
import EirButton from '../eir-button/EirButton';



function EirBusinessProductTile(props) {

    const renderContent = (content) => {
        return { __html: content };
    }

    const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)
    const myRef = useRef(null)
    //To get background based on device
    const getBackgroundImage = () => {
        if (isMobile && !isTablet) {
            return (props.mobileBackgroundImage) ? props.mobileBackgroundImage.path : '';
        }
        return (props.backgroundImage) ? props.backgroundImage.path : '';
    }
    const [displayTiles, setDisplayTiles] = React.useState((props.desktoptiles.length > 6) ? props.desktoptiles.slice(0, 30) : props.desktoptiles);
    const [displayPagination, setdisplayPagination] = React.useState((props.desktoptiles.length > 30) ? true : false);
    const [displayPaginationCount, setdisplayPaginationCount] = React.useState((parseInt(props.desktoptiles.length / 30)) + 1);
    const [pageBottom, setPageBottom] = React.useState(false);
    const [displayMobileTiles, setDisplayMobileTiles] = React.useState((props.mobiletiles.length > 6) ? props.mobiletiles.slice(0, 30) : props.mobiletiles);
    const [displayMobilePagination, setdisplayMobilePagination] = React.useState((props.mobiletiles.length > 30) ? true : false);
    const [displayPaginationMobileCount, setdisplayPaginationMobileCount] = React.useState((parseInt(props.mobiletiles.length / 30)) + 1);
    const [bottomCTA] = React.useState(props.BottomCTA);
    const [stylingCTA] = React.useState({
        backgroundColor: props.BottomCTABackgroundColor,
        color: props.BottomCTAFontColor,
        borderColor: props.BottomCTAOutlineColor,
        hover: {
            backgroundColor: props.BottomCTABackgroundHoverColor,
            color: props.BottomCTAFontHoverColor,
            borderColor: props.BottomCTAOutlineHoverColor,
        }
    })
    
    //var displayTiles = ((props.desktoptiles.length>6)? props.desktoptiles.slice(0, 6):props.desktoptiles)
    useEffect(() => {
        //Logic to display same height for all the tiles in a row irrespective of content

        if (!isMobile || isTablet) {

            let getParentReference = document.getElementById("business-pdt-tiles-ctr-" + props.occurence);
            var tiles = getParentReference.querySelectorAll(".three-six-desktop .tile-content");
            var tileTitle = getParentReference.querySelectorAll(".three-six-desktop .three_six_titlearea");
            if (props.desktoptiles.length < 7) {
                setTimeout(function () {
                    var firstRowTiles = [];
                    var firstRowTileTitles = [];

                    var firstRowLastIndex = (tiles.length == 5 || tiles.length == 6) ? (tiles.length == 5) ? 3 : parseInt(tiles.length / 2) : tiles.length;

                    for (var i = 0; i < firstRowLastIndex; i++) {
                        firstRowTiles.push(parseInt(tiles[i].clientHeight));
                        firstRowTileTitles.push(parseInt(tileTitle[i].clientHeight));
                    }
                    for (var i = 0; i < firstRowLastIndex; i++) {
                        tiles[i].style.height = Math.max.apply(Math, firstRowTiles) + "px";
                        tileTitle[i].style.height = Math.max.apply(Math, firstRowTileTitles) + "px";
                    }

                    var secondRowTiles = [];
                    var secondRowTileTitles = [];
                    for (var i = firstRowLastIndex; i < tiles.length; i++) {
                        secondRowTiles.push(parseInt(tiles[i].clientHeight));
                        secondRowTileTitles.push(parseInt(tileTitle[i].clientHeight));
                        tiles[i].style.height = Math.max.apply(Math, secondRowTiles) + "px";
                    }
                    for (var i = firstRowLastIndex; i < tiles.length; i++) {
                        tiles[i].style.height = Math.max.apply(Math, secondRowTiles) + "px";
                        tileTitle[i].style.height = Math.max.apply(Math, secondRowTileTitles) + "px";
                    }
                }, 3000);
            }
            else {
                moretiles();
            }
            if(pageBottom){
            scrollToRef(myRef);
            setPageBottom(false);
            }
        }
    })
    const handleChange = (event, value) => {
        setPageBottom(true);
        setDisplayTiles([]);
        let displayTileFirstIndex = ((value == 1) ? 0 : 30);
        let displayTileLastIndex = (displayTileFirstIndex + 30);

        let getParentReference = document.getElementById("business-pdt-tiles-ctr-" + props.occurence);
        var tiles = getParentReference.querySelectorAll(".three-six-desktop .tile-content");
        var tileTitle = getParentReference.querySelectorAll(".three-six-desktop .three_six_titlearea");

        for (var k = 0; k < tiles.length; k++) {
            tiles[k].removeAttribute("style");
            tileTitle[k].removeAttribute("style");
        }
        setDisplayTiles(props.desktoptiles.slice(displayTileFirstIndex, displayTileLastIndex));
        setPage(value);
        moretiles();
        
    };

    const handleMobileChange = (event, value) => {
        setPageBottom(true);
        setDisplayMobileTiles([]);
        let displayTileFirstIndex = ((value == 1) ? 0 : 30);
        let displayTileLastIndex = (displayTileFirstIndex + 30);
        setDisplayMobileTiles(props.mobiletiles.slice(displayTileFirstIndex, displayTileLastIndex));
        setPage(value);
    };


    const moretiles = () => {
        setTimeout(function () {
            let getParentReference = document.getElementById("business-pdt-tiles-ctr-" + props.occurence);
            var tiles = getParentReference.querySelectorAll(".three-six-desktop .tile-content");
            var tileTitle = getParentReference.querySelectorAll(".three-six-desktop .three_six_titlearea");

            var RowTiles = [];
            var RowTileTitles = [];
            for (var k = 0; k < tiles.length; k += 3) {
                for (var i = k; i < k + 3; i++) {
                    (tiles[i]) ? RowTiles.push(parseInt(tiles[i].clientHeight)) : '';
                    (tiles[i]) ? RowTileTitles.push(parseInt(tileTitle[i].clientHeight)) : '';
                }
                for (var j = k; j < k + 3; j++) {
                    tiles[j].style.height = Math.max.apply(Math, RowTiles) + "px";
                    tileTitle[j].style.height = Math.max.apply(Math, RowTileTitles) + "px";
                }
                RowTiles = [];
                RowTileTitles = [];
            }

        }, 2000);
    }
    const getBackgroundColor = () => {
        if (isMobile && !isTablet) {
            return (props.mobileBackgroundColor) ? props.mobileBackgroundColor : '';
        }
        return (props.backgroundColor) ? props.backgroundColor : '';
    }

    let singleBottomTile = false;
    if((props.desktoptiles.length > 4) && (props.desktoptiles.length %3 == 1))
    {
        singleBottomTile = true;
    }
    
    let twoBottomTile = false;
    if((props.desktoptiles.length > 2) && (props.desktoptiles.length %2 == 1))
    {
        twoBottomTile = true;
    }
    
    let BottomCTAprops = (bottomCTA != undefined ? ({
        text : bottomCTA.text, 
        title : bottomCTA.title, 
        link : bottomCTA.link, 
        target: bottomCTA.target, 
        type : bottomCTA.type, 
        icon : bottomCTA.icon,
        buttonStyle : bottomCTA.buttonStyle, 
        buttonSize : bottomCTA.buttonSize,
        theme : bottomCTA.theme,
        videoModal : bottomCTA.VideoModal,
        styling : stylingCTA

    }) : {});

    let ProductTileDesign;
    switch (props.BusinessProductTileDesign) {
        case ("Rectangle"): {
            ProductTileDesign = false;
            break;
        }
        case ("Circle"): {
            ProductTileDesign = true;
            break;
        }
        default: {
            ProductTileDesign = false;
            break;
        }
    }

    let [marginDesktop, marginMobile] = moduleMargins(props.MarginDT, props.MarginMobile);
    
    return (

        <div id={"business-pdt-tiles-ctr-" + props.occurence} class={"business-product-tile-main " + ((!isMobileOnly) ? marginDesktop : marginMobile) + (LargeBusiness.isLBSite? " business-product-tile-main-lb" + (ProductTileDesign? " business-product-tile-main-circle" : "") : "")}>
            {(!isMobile || isTablet) && (props.HideComponent !== "Desktop") && (props.HideComponent !== "Both") &&
                <div className='pt-4 pb-5' style={{
                    backgroundImage: "url(" + getBackgroundImage() + ")",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: getBackgroundColor(),
                }} >

                    <div className={`homepage-modules-title container ${htmlWidget}`} dangerouslySetInnerHTML={renderContent(props.moduleDesktopTitle)}></div>
                    <Container className={isMobileOnly ? 'mobilelandscapeContainer' : ''}>
                        <Row className="justify-content-center">
                            {displayTiles.map((tile, i) => {
                                return (
                                    <Col key={i} className={'three-six-desktop mt-mb-30 ' + (((!displayPagination) && (displayTiles.length == 2 || displayTiles.length == 1)) ? 'col-6' + ((displayTiles.length == 1) ? " col-6-lb" : "") : ((!displayPagination) && (displayTiles.length == 4)) ? 'col-3' : 'col-4' + (singleBottomTile? ' col-4-lb' : "") + (twoBottomTile? ' col-4-lb-2' : ""))} >
                                        <Card className="three_six_card">
                                            <BusinessGeneralTile image={tile.image.path} id={'Product tile CTA ' + (i + 1)}
                                                title={tile.title}
                                                subtitle={tile.subtitle}
                                                subtitleOld={ProductTileDesign}
                                                text={tile.text}
                                                alt={tile.altText}
                                                cta={tile.cta}
                                                clickable={tile.Clickable}
                                                ctaOutline={tile.OutlineColorCTA}
                                                ctaOutlineHover={tile.OutlineColorHoverCTA}
                                                ctaBackground={tile.BackgroundColorCTA}
                                                ctaBackgroundHover={tile.BackgroundColorHoverCTA}
                                                ctaFont={tile.FontColorCTA}
                                                ctaFontHover={tile.FontColorHoverCTA}
                                                ctaAlignment={tile.AlignmentCTA}
                                                arrow={tile.ArrowImage}
                                                arrowHover={tile.ArrowHoverImage}>
                                            </BusinessGeneralTile>
                                        </Card>
                                    </Col>
                                );
                            })
                            }
                        </Row>
                        {displayPagination &&
                            <div ref={myRef} className=" mt-4 d-flex justify-content-center align-items-center">
                                <Pagination count={displayPaginationCount} color="primary" size="large" variant="outlined" onChange={handleChange} />
                            </div>
                        }
                    </Container>
                    {bottomCTA != undefined &&
                    <Container className="productTileBottomCTA-lb">
                    <EirButton {...BottomCTAprops} justifyContent= "justify-content-center">
                    </EirButton>
                    </Container>}
                </div>

            }
            {(isMobile && !isTablet) && (props.HideComponent !== "Mobile") && (props.HideComponent !== "Both") &&
                <div className='pt-4 pb-5' style={{
                    backgroundImage: "url(" + getBackgroundImage() + ")",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: getBackgroundColor(),
                }} >

                    <div className={`homepage-modules-title ${htmlWidget}`} dangerouslySetInnerHTML={renderContent(props.moduleMobileTitle)}></div>
                    <Container className={isMobileOnly ? 'mobilelandscapeContainer' : ''}>
                        <Row>
                            {displayMobileTiles.map((tile, i) => {
                                return (
                                    <Col key={i} className="three-six-mobile col-12 mt-mb-30 mobile-single-tile" >
                                        <Card className="three_six_card">
                                            <BusinessGeneralTile image={tile.image.path}
                                                id={'Product tile CTA ' + (i + 1)}
                                                title={tile.title}
                                                subtitle={tile.subtitle}
                                                subtitleOld={ProductTileDesign}
                                                text={tile.text}
                                                alt={tile.altText}
                                                cta={tile.cta}
                                                clickable={tile.Clickable}
                                                ctaOutline={tile.OutlineColorCTA}
                                                ctaOutlineHover={tile.OutlineColorHoverCTA}
                                                ctaBackground={tile.BackgroundColorCTA}
                                                ctaBackgroundHover={tile.BackgroundColorHoverCTA}
                                                ctaFont={tile.FontColorCTA}
                                                ctaFontHover={tile.FontColorHoverCTA}
                                                ctaAlignment={tile.AlignmentCTA}
                                                arrow={tile.ArrowImage}
                                                arrowHover={tile.ArrowHoverImage} >
                                            </BusinessGeneralTile>
                                        </Card>
                                    </Col>
                                );
                            })
                            }
                        </Row>
                        {displayMobilePagination &&
                            <div ref={myRef} className=" mt-4 d-flex justify-content-center align-items-center">
                                <Pagination count={displayPaginationMobileCount} color="primary" size="large" variant="outlined" onChange={handleMobileChange} />
                            </div>
                        }
                    </Container>
                    {bottomCTA != undefined &&
                    <Container className="productTileBottomCTA-lb">
                    <EirButton {...BottomCTAprops} justifyContent= "justify-content-center">
                    </EirButton>
                    </Container>}
                </div>
            }
        </div>
    );
}
export default EirBusinessProductTile;

